<template lang="pug">
  .filters
    BaseInput.search(:value="filters.projectName" @input="changeFilters($event, 'projectName')" label="Поиск проекта" iconName="search")
    BaseSelect.sorter.select(:value="sortValue" @input="changeSorter" :options="sorterOptions" notSelectedLabel="По умолчанию" label="Сортировка")
    BaseSelectMulti.users.select(:value="filters.authors" @input="changeFilters($event, 'authors')" :options="authorsOptions" label="Руководитель")
    BaseSelectMulti.users.select(:value="filters.members" @input="changeFilters($event, 'members')" :options="membersOptions" label="Специалисты")
    BaseSelectMulti.users.select(:value="filters.departments" @input="changeFilters($event, 'departments')" :options="departmentOptions" label="Отделы")
    .clear-icon(title="Очистить фильтр" @click="clearFilters")
      Icon(name="filter" pointer)
    .tab-container
      BaseTabs.tab-container(:tabs="tabsOptions" :value="orientationType" blue big @input="$emit('changeOrientationType', $event)")
</template>

<script>
import BaseInput from '@/components/BaseInput.vue';
import BaseSelect from '@/components/BaseSelect.vue';
import BaseSelectMulti from '@/components/BaseSelectMulti.vue';
import BaseCheckbox from '@/components/BaseCheckbox.vue';
import BaseTabs from '@/components/BaseTabs.vue';

export default {
  name: 'ProjectFileFiltersContainer',
  components: {
    BaseInput, BaseSelect, BaseTabs, BaseSelectMulti, BaseCheckbox,
  },
  props: {
    filters: {
      type: Object,
      default: () => ({}),
    },
    projects: {
      type: Array,
      default: () => [],
    },
    companies: {
      type: Array,
      default: () => [],
    },
    sorter: Object,
    orientationType: String,
  },
  data() {
    return {
      device: 'desktop',
      tabsOptions: [{ value: 'rectangle', icon: 'square-lined' }, { value: 'square', icon: 'square-dotted' }],
      sorterOptions: [
        { value: 'asc_name', label: 'По названию', icon: 'arrow-up' },
        { value: 'desc_name', label: 'По названию', icon: 'arrow-down' },
        { value: 'asc_dateStart', label: 'По дате создания', icon: 'arrow-up' },
        { value: 'desc_dateStart', label: 'По дате создания', icon: 'arrow-down' },
        { value: 'asc_dateFinish', label: 'По дате завершения', icon: 'arrow-up' },
        { value: 'desc_dateFinish', label: 'По дате заверешния', icon: 'arrow-down' },
        { value: 'asc_dateProgress', label: 'По срокам проекта', icon: 'arrow-up' },
        { value: 'desc_dateProgress', label: 'По срокам проекта', icon: 'arrow-down' },
        { value: 'asc_taskProgress', label: 'По прогрессу', icon: 'arrow-up' },
        { value: 'desc_taskProgress', label: 'По прогрессу', icon: 'arrow-down' },
        { value: 'asc_authorName', label: 'По имени автора', icon: 'arrow-up' },
        { value: 'desc_authorName', label: 'По имени автора', icon: 'arrow-down' },
      ],
    };
  },
  computed: {
    membersOptions() {
      const nonUnique = this.projects
        .reduce((acc, val) => [
          ...acc,
          ...(val?.projectMembers ?? []).map(m => m.user),
          val?.author,
        ], []);

      return Object.values(nonUnique.reduce((acc, value) => ({ ...acc, [value['@id']]: value }), {}))
        .map((u) => ({ value: u['@id'], label: `${u.name} ${u.surname}` }));
    },
    departmentOptions() {
      const projectDepartments = this.projects
        .map(p => p.companyDepartment?.['@id'])
        .filter(p => p);

      return this.companies.reduce((acc, val) => [
        ...acc,
        ...val.departments
          .filter(d => projectDepartments.includes(d['@id']))
          .map(m => ({ value: m['@id'], label: `${m.name}, ${val.name}` }))
      ], [])
    },

    authorsOptions() {
      const nonUnique = this.projects.map((p) => p.author);

      return Object.values(nonUnique.reduce((acc, value) => ({ ...acc, [value['@id']]: value }), {}))
        .map((u) => ({ value: u['@id'], label: `${u.name} ${u.surname}` }));
    },
    sortValue() {
      const { direction, value } = this.sorter;
      return direction ? `${direction}_${value}` : null;
    },
  },
  methods: {
    changeFilters(value, field) {
      this.$emit('changeFilters', value, field);
    },
    clearFilters() {
      this.$emit('clearFilters');
    },
    changeSorter(value) {
      this.$emit('changeSorter', value);
    },
  },
};
</script>

<style scoped lang="scss">
.filters {
  display: grid;
  grid-template-columns: 1fr 210px 170px 170px 130px min-content min-content;
  align-content: center;
  gap: 16px;

  .clear-icon {
    cursor: pointer;
    width: 43px;
    height: 38px;
    background: var(--color-super-light);
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    stroke: var(--color-middle-gray);

    &:hover {
      stroke: var(--color-accent);
    }
  }

  @media (max-width: 1350px) {
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
    gap: 10px;

    .search {
      grid-column: 1 / 2 span;
    }

    .select {
      grid-column: 2 span;
    }

    .tab-container {
      display: flex;
      justify-self: end;
    }
  }

  @media (max-width: 767.98px) {
    .tab-container {
      display: none;
    }
  }

  @media (max-width: 576px) {
    grid-template-columns: 1fr 45px;

    .search, .select {
      grid-column: 2 span;
    }
  }
}
</style>
